import React, { useCallback, useEffect, useState } from 'react';
import Text from 'antd/lib/typography/Text';
import '@ant-design/compatible/assets/index.css';
import {
  Form,
  Col,
  Row,
  Card,
  DatePicker,
  Input,
  TimePicker,
  Modal,
  Spin,
} from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { assetUseResponsesRes, getProposalById } from 'services/proposal';
import { FormInstance } from 'antd/es/form';
import { indexBy, toDatePickerDate } from 'utils/utils2';
import AssetUsersSelect from 'components/AssetUsersSelect';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import Address from 'components/address';
import FormInput from 'components/FormInput';
import UtinaCard from 'components/UtinaCard';
import { isEmpty } from 'lodash';
import moment from 'moment';

export type TabpreparedAssetForDeliveryProps = {
  form: FormInstance;
  objectid?: number;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  objectreference?: string;
  entityName?: string;
  setSuccessful: any;
};

const TabpreparedAssetForDelivery = (
  props: TabpreparedAssetForDeliveryProps
) => {
  const { setSuccessful, form, objectid } = props;

  const fieldName = 'assetList';
  const [state, setState] = useState<any>({
    isLoading: false,
    selectedRowKeys: [],
    ASSETLIST: [],
    currcode: localStorage.getItem('currcode') ?? '',
  });

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const loadProposaletail = useCallback(
    (ctrid) => {
      setSuccessful(true);

      getProposalById({ ctrid }).then((response) => {
        const contract = response.data;

        updateState({
          ASSETLIST: contract.assets.map((asset: any) => ({
            ...asset,
            deliveryadrstreet1: asset.deliveryadrstreet1,
            deliveryadrstreet2: asset.deliveryadrstreet2,
            deliveryadrzipcode: asset.deliveryadrzipcode,
            deliveryadrcountry: asset.deliveryadrcountry,
            deliveryadrregion: asset.deliveryadrregion,
            deliveryadrcity: asset.deliveryadrcity,
            registrationdate: toDatePickerDate(asset.registrationdate),
            firstregistrationdate: toDatePickerDate(
              asset.firstregistrationdate
            ),
            startdate: toDatePickerDate(asset.startdate),
          })),
        });
      });
    },
    [form, updateState]
  );
  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      let listAsset = '';
      for (const i in selectedRows) {
        listAsset = selectedRows[i].assetid + `,` + listAsset;
        form.setFieldsValue({
          row: Number(i),
        });
      }

      selectedRows.forEach((row: any, index: number) => {
        form.setFieldsValue({
          assetid: row.assetid,
        });
      });

      setSuccessful(selectedRowKeys?.length > 0 ? false : true);
    },
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState<any>('');
  const showModal = (address: string) => {
    setModalContent(address);
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (state.ASSETLIST) {
      form.setFieldsValue({
        [fieldName]: state.ASSETLIST.map((data: any) => ({
          ...data,
        })),
      });
    }
    // if(form){
    //   form.setFieldsValue({
    //     deliveryadrstreet1:form.getFieldValue('deliveryadrstreet1'),
    //     deliveryaddress: form.getFieldValue('deliveryadrstreet1'),
    //     deliveryadrzipcode: form.getFieldValue('deliveryadrzipcode'),
    //     deliveryadrcountry: form.getFieldValue('deliveryadrcountry'),
    //     deliveryadrregion: form.getFieldValue('deliveryadrregion'),
    //     registrationdate: toDatePickerDate(form.getFieldValue('registrationdate')),
    //     firstregistrationdate: toDatePickerDate(form.getFieldValue('firstregistrationdate')),
    //     startdate: toDatePickerDate(form.getFieldValue('startdate'))
    //   })
    // }
    form.setFieldValue('event', 'tabpreparedAssetForDelivery');

    if (modalContent) {
      form.setFieldsValue({
        deliveryadrstreet1: modalContent.deliveryadrstreet1,
        deliveryadrzipcode: modalContent.deliveryadrzipcode,
        deliveryadrstreet2: modalContent.deliveryadrstreet2,
        deliveryadrregion: modalContent.deliveryadrregion,
        deliveryadrcountry: modalContent.deliveryadrcountry,
        deliveryadrcity: modalContent.deliveryadrcity,
      });
    }
  }, [form, state.ASSETLIST, modalContent]);

  useEffect(() => {
    loadProposaletail(objectid);
  }, [objectid]);

  const getName = useCallback(
    (name: string) => (record: assetUseResponsesRes) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'assetid')[record.assetid];

      return [fieldName, index, name];
    },
    [form]
  );

  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'Asset.assetlabel',
      dataIndex: 'assetlabel',
      width: 180,
      fixed: 'left',
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('assetlabel')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.statuslabel',
      dataIndex: 'status',
      width: 100,
      fixed: 'left',
      render: (index, record) => <Text>{record.statuslabel}</Text>,
    },
    {
      comcode: 'deliveryadrstreet1',
      dataIndex: 'deliveryadrstreet1',
      width: 180,
      fixed: 'left',
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('deliveryadrstreet1')(record)}>
            <Input
              color="primary"
              suffix={
                <HomeOutlined
                  style={{ color: '#00000040', cursor: 'pointer' }}
                  onClick={() => showModal(record)}
                />
              }
              max={800}
              onClick={() => showModal(record)}
              value={value}
            />
          </Form.Item>
        );
      },
    },

    {
      comcode: 'Asset.startdate',
      dataIndex: 'startdate',
      width: 150,
      fixed: 'left',
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('startdate')(record)}>
            <DatePicker />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.assetdeliverytime',
      dataIndex: 'assetdeliverytime',
      width: 150,
      fixed: 'left',
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('assetdeliverytime')(record)}>
            <TimePicker
              format="HH:mm"
              value={
                record.assetdeliverytime
                  ? moment(record.assetdeliverytime, 'HH:mm')
                  : null
              }
            />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.serialno',
      dataIndex: 'serialno',
      width: 150,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('serialno')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.chassisno',
      dataIndex: 'chassisno',
      width: 150,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('chassisno')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.plateno',
      dataIndex: 'plateno',
      width: 150,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('plateno')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.engineno',
      dataIndex: 'engineno',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('engineno')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.fiscalpower',
      dataIndex: 'fiscalpower',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('fiscalpower')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.weight',
      dataIndex: 'weight',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('weight')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.registrationno',
      dataIndex: 'registrationno',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('registrationno')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.registrationname',
      dataIndex: 'registrationname',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('registrationname')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.registrationdate',
      dataIndex: 'registrationdate',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('registrationdate')(record)}>
            <DatePicker />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.registrationcity',
      dataIndex: 'registrationcity',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('registrationcity')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.firstregistrationdate',
      dataIndex: 'firstregistrationdate',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('firstregistrationdate')(record)}>
            <DatePicker />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'Asset.assetUsers',
      dataIndex: 'assetUsers',
      fixed: 'right',
      width: 180,
      render: (value, record) => {
        return (
          <Form.Item noStyle name={getName('assetUsers')(record)}>
            <AssetUsersSelect
              assetid={record.assetid}
              selectedRowKeys
              onChange={(e: any) => {
                form.setFieldsValue({ relcode: e.relcode, reltype: e.reltype });
              }}
            />
          </Form.Item>
        );
      },
    },
  ];

  return (
    <DF.Provider pagcode="tabpreparedassetfordelivery">
      <Spin spinning={!isEmpty(form.getFieldsValue()) ? false : true}>
        <Form form={form}>
          <Form.Item shouldUpdate noStyle>
            <Card title={<GetLabel label="Assets" />}>
              <Row gutter={16}>
                <Col span={24}>
                  <DataGrid
                    rowKey={(k) => k.assetid}
                    rowSelection={{
                      type: 'checkbox',
                      ...rowSelection,
                    }}
                    dataSource={state.ASSETLIST}
                    columns={columns}
                    {...props}
                  />
                </Col>
              </Row>
            </Card>
            <Modal
              title="Delivery Address"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              style={{ backgroundColor: '#ffff' }}
              width={800}
            >
              <UtinaCard
                level={5}
                comcode="delivery-address"
                style={{ color: '#000', marginLeft: 30 }}
              >
                <FormInput
                  shouldUpdate
                  col
                  xs={24}
                  md={24}
                  style={{ marginBottom: '30px' }}
                  name="deliveryadrstreet1"
                  // labelCol={{ span: 8 }}
                >
                  <Input
                    onChange={(e) => {
                      const newValue = e.target.value;
                      form.setFieldsValue({ deliveryadrstreet1: newValue });
                      setModalContent((prev: any) => ({
                        ...prev,
                        deliveryadrstreet1: newValue,
                      }));
                      setState((prev: any) => {
                        const updatedList = prev.ASSETLIST.map((item: any) => ({
                          ...item,
                          deliveryadrstreet1: newValue,
                        }));
                        return { ...prev, ASSETLIST: updatedList };
                      });
                    }}
                  />
                </FormInput>
                <FormInput
                  shouldUpdate
                  col
                  xs={24}
                  md={24}
                  style={{ marginBottom: '30px' }}
                  name="deliveryadrstreet2"
                  // labelCol={{ span: 8 }}
                />
                <Address
                  form={form}
                  codePostalField="deliveryadrzipcode"
                  paysField="deliveryadrcountry"
                  regionField="deliveryadrregion"
                  villeField="deliveryadrcity"
                  colU={12}
                  hideRegionGlobal
                  Colw={
                    localStorage.getItem('lancode') === 'FR'
                      ? { span: 8 }
                      : { span: 8 }
                  }
                  styles={{ marginBottom: '30px' }}
                />
              </UtinaCard>
            </Modal>
          </Form.Item>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
export default TabpreparedAssetForDelivery;
